export enum TextTemplateReceiverType {
  AGENT = "AGENT",     // Driver
  ISSUER = "ISSUER",     // Shipper
  RECIPIENT = "RECIPIENT",
  SENDER = "SENDER",
  ALL = "ALL",
  ADMIN = "ADMIN",
  BRANCH_CONTACTS = "BRANCH_CONTACTS",
  TEAM_CONTACTS = 'TEAM_CONTACTS',
  OPERATIONAL_CONTACTS = 'OPERATIONAL_CONTACTS'
}
